jQuery(document).ready(function () {
    if (window.innerWidth > 768) {
        jQuery(".sticky-element").stick_in_parent({
            parent: '.sticky-container',
            offset_top: 0,
        });
    }

    jQuery('.box-click-js').click(function (evt) {
        evt.stopPropagation();
        evt.preventDefault();
        evt = jQuery(evt.currentTarget);
        document.location = evt.find('a').attr('href');
        return false;
    });

    jQuery('.fancybox-cms').fancybox({
        'width': '95%',
        'height': '98%',
        'maxWidth': '900px',
        //'maxHeight' : '900px',
        'fitToView': false,
        'autosize': false,
        'autoDimensions': false,
        'hideOnContentClick': true,
        'transitionIn': 'elastic',
        'transitionOut': 'elastic',
        'padding': 10,
        'showCloseButton': true,
        'type': 'iframe',
        'beforeShow': function () {
            this.title = false;
        },
    });

    /* pulsante condividi post */
    // jQuery('.gb-share-list a').click(function (str) {
    //     str = jQuery(this).find('i').attr('class');
    //     str = str.replace('fa fa-', '');
    //     dataLayer.push({
    //         'event': 'GAevent',
    //         'eventCategory': 'Condividi sui social',
    //         'eventAction': str,
    //     });
    // });

    /* pulsanti header carrello */
    // jQuery(document).on('click', '#cart_block_summary a.icon-cart, #cart_block_list #button_order_cart', function (evt) {
    //     evt.stopPropagation();
    //     evt.preventDefault();
    //     dataLayer.push({
    //         'event': 'GAevent',
    //         'eventCategory': 'Carrello Blog',
    //         'eventAction': 'Vai al carrello',
    //     });
    //     if (jQuery(this).attr('target') == '_blank' || (evt.ctrlKey || evt.metaKey)) {
    //         window.open(jQuery(this).attr('href'));
    //         return false;
    //     } else {
    //         document.location = jQuery(this).attr('href');
    //         return false;
    //     }
    // });

    /* tracciamento menu blog */
    // jQuery(document).on('click', '#main-menu-nav a', function (evt) {
    //     evt.stopPropagation();
    //     evt.preventDefault();
    //     dataLayer.push({
    //         'event': 'GAevent',
    //         'eventCategory': 'Menu Blog',
    //         'eventAction': jQuery(this).text(),
    //         //'eventLabel' : jQuery(this).text()
    //     });
    //     if (jQuery(this).attr('target') == '_blank' || (evt.ctrlKey || evt.metaKey)) {
    //         window.open(jQuery(this).attr('href'));
    //         return false;
    //     } else {
    //         document.location = jQuery(this).attr('href');
    //         return false;
    //     }
    // });
});

// eslint-disable-next-line no-unused-vars
window.loadPSuserBar = function(lang) {
    jQuery.ajax({
        url: "https://www.gastrodomus.it/advivaTools/ajax-templates/ajax-user-bar.php", // se richista la lingua nell'url aggiungere ?lang=+lang
        beforeSend: function (xhr) {
            xhr.overrideMimeType("text/plain; charset=utf-8");
        },
    }).done(function (data) {
        jQuery('#shop-toolbar').html(data);

        CartHover()
    });
}

// Loads the shop's real theme header (CSS + markup + JS) into #shop-toolbar.
window.loadPSHeader = function() {
    var base = "https://www.gastrodomus.it/advivaTools/ajax-templates/ajax-header.php";

    jQuery.getJSON(base + "?format=json").done(function (data) {
        var head = document.head;

        data.css.external.forEach(function (sheet) {
            var link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = sheet.uri;
            link.media = sheet.media || "all";
            head.appendChild(link);
        });
        data.css.inline.forEach(function (css) {
            var style = document.createElement("style");
            style.textContent = css;
            head.appendChild(style);
        });

        // Mounted outside #site-masthead: the blog styles there target the old shop bar.
        document.getElementById("shop-header").innerHTML = data.html;
        document.getElementById("shop-toolbar").style.display = "none";

        // Newsletter module config, normally printed in the shop footer.
        window.bt_nl_form = window.bt_nl_form || {};
        window.bt_nl_module = window.bt_nl_module || {};

        // The shop's head bundle ships its own jQuery (1.11) plus plugins, and the
        // bottom bundle registers ready callbacks that use them. Head runs as a
        // normal script (then the blog's jQuery is put back); bottom runs inside a
        // function that receives the shop jQuery as $/jQuery, so its deferred
        // callbacks keep using it.
        var blogJq = window.jQuery;
        var blog$ = window.$;

        // jQuery 3 removed the .load(handler) event shorthand; the shop bundle still
        // uses it (jQuery(window).load(fn)) and can end up on the blog's jQuery 3.
        // Restore the shorthand when the first argument is a function.
        if (!blogJq.fn.load.__legacyShim) {
            var ajaxLoad = blogJq.fn.load;
            blogJq.fn.load = function (arg) {
                if (typeof arg === "function") {
                    return this.on.apply(this, ["load"].concat([].slice.call(arguments)));
                }
                return ajaxLoad.apply(this, arguments);
            };
            blogJq.fn.load.__legacyShim = true;
        }
        var shopJq = null;
        var bundleUrl = /\/themes\/panda\/assets\/cache\/((head|bottom)-[a-f0-9]+\.js)$/;

        function restoreBlogJq() {
            window.jQuery = blogJq;
            window.$ = blog$;
        }

        function runBundle(kind, code) {
            try {
                if (kind === "head") {
                    (0, eval)(code);
                    shopJq = window.jQuery;
                } else {
                    new Function("$", "jQuery", code).call(window, shopJq, shopJq);
                }
            } catch (e) {
                console.error("loadPSHeader: " + kind + " bundle failed:", e);
            }
            restoreBlogJq();
        }

        var queue = data.js.slice();
        (function next() {
            var item = queue.shift();
            if (!item) {
                restoreBlogJq();
                CartHover();
                return;
            }
            var bundle = item.src && item.src.match(bundleUrl);
            if (bundle) {
                jQuery.ajax({
                    url: base + "?asset=" + bundle[1],
                    dataType: "text",
                }).done(function (code) {
                    runBundle(bundle[2], code);
                }).fail(function (xhr, status) {
                    console.error("loadPSHeader: cannot load", item.src, status);
                }).always(next);
                return;
            }
            var script = document.createElement("script");
            if (item.src) {
                script.src = item.src;
                script.onload = next;
                script.onerror = next;
                document.body.appendChild(script);
            } else {
                script.textContent = item.inline;
                document.body.appendChild(script);
                next();
            }
        })();
    }).fail(function (xhr, status, error) {
        console.error("loadPSHeader failed:", status, error, xhr.status, (xhr.responseText || "").slice(0, 300));
    });
};

function CartHover() {
    // desktop
    let cart_listener = document.getElementById("cart_hover_trigger");

    if (cart_listener) {
        cart_listener.addEventListener("mouseenter", function () {
            $(".wtajaxcart").finish().fadeIn();
        }, false);

        cart_listener.addEventListener("mouseleave", function () {
            $(".wtajaxcart").finish().fadeOut();
        }, false);
    }
}

function toTopManage() {
    var t = jQuery(window).scrollTop();
    if (t > 300) {
        jQuery('#toTop').fadeIn();
    } else {
        jQuery('#toTop').fadeOut();
    }
}
jQuery(window).scroll(function () {
    toTopManage();
});
